/* Nanref motion layer v3 (2026-10-05), every page: card add-to-cart feedback, scroll reveal, sticky-header state. Pairs with nanref-motion.css. */
(function () {
  // ---------- Add to cart from product cards: stay on the page, confirm on the button, then open the cart drawer ----------
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var live = null;
  function announce(text) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'nanref-visually-hidden';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = text;
  }
  function setLabel(btn, text, state) {
    if (state) btn.dataset.state = state; else delete btn.dataset.state;
    var label = btn.querySelector('.nr-label');
    if (!label) { label = document.createElement('span'); label.className = 'nr-label'; label.textContent = btn.textContent; btn.textContent = ''; btn.appendChild(label); }
    if (reduce || !label.animate) { label.textContent = text; return; }
    // Crossfade with a little blur so the two words read as one change, not two objects swapping.
    var out = label.animate([{ opacity: 1, filter: 'blur(0)' }, { opacity: 0, filter: 'blur(2px)' }], { duration: 110, easing: 'ease', fill: 'forwards' });
    out.onfinish = function () {
      label.textContent = text;
      out.cancel();
      label.animate([{ opacity: 0, filter: 'blur(2px)', transform: 'translateY(3px)' }, { opacity: 1, filter: 'blur(0)', transform: 'none' }], { duration: 200, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
    };
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.nanref-product__form')) return;
    var actions = window.Shopify && Shopify.actions;
    var btn = form.querySelector('button[type="submit"]');
    var id = form.querySelector('input[name="id"]');
    if (!actions || typeof actions.updateCart !== 'function' || !btn || !id) return; // normal form post
    e.preventDefault();
    if (btn.dataset.state) return; // ignore repeat taps while busy
    var original = btn.textContent.trim();
    btn.style.minWidth = btn.offsetWidth + 'px'; // label changes must not resize the button
    setLabel(btn, 'Adding…', 'adding');
    function reset() { setLabel(btn, original, ''); btn.style.minWidth = ''; }
    actions.updateCart({ lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + id.value, quantity: 1 }] })
      .then(function (res) {
        if (res && res.userErrors && res.userErrors.length) {
          setLabel(btn, "Couldn't add", 'error');
          announce(res.userErrors[0].message || "Couldn't add to cart");
          if (!reduce && btn.animate) btn.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(-3px)' }, { transform: 'translateX(2px)' }, { transform: 'translateX(0)' }], { duration: 320, easing: 'ease-out' });
          setTimeout(reset, 2000);
          return;
        }
        setLabel(btn, 'Added ✓', 'added');
        announce('Added to cart');
        setTimeout(function () { if (typeof actions.openCart === 'function') actions.openCart(); }, 450);
        setTimeout(reset, 2200);
      })
      .catch(function () { reset(); form.submit(); }); // fall back to the normal add-to-cart page
  });
})();

(function () {
  var root = document.documentElement;
  if (!root.classList.contains('nanref-motion') || !('IntersectionObserver' in window)) return;
  window.__nrReady = 1;

  // Must match the hidden-state list in nanref-motion.css (section 2).
  var SEL = [
    '.nanref-benefits__grid>*',
    '[id*="collection_list_nanref"] .section-resource-list__content',
    '#MainContent .resource-list__item',
    '.nanref-section-head',
    '.nanref-room__grid>*',
    '.nanref-bestsellers__grid>*',
    '.nanref-story__media',
    '.nanref-story__copy>*',
    '.nanref-signup__panel',
    '#MainContent>.shopify-section:has(.jdgm-cards-carousel)',
    '.nanref-room__subcats li',
    '.nanref-room__grid-title',
    '.nanref-room-setup h2',
    '.nanref-room-setup__card',
    '.nanref-room-other h2',
    '.nanref-room-other__card',
    '.nanref-pdp-details__main>*',
    '.nanref-pdp-details__aside>*',
    '.nanref-pdp-related__head',
    '.nanref-about__founder-photo',
    '.nanref-about__founder-copy>*',
    '.nanref-about__belief h2',
    '.nanref-about__belief-text>*',
    '.nanref-about__head',
    '.nanref-about__steps>li',
    '.nanref-about__rooms-grid>*',
    '.nanref-about__promise-grid>li',
    '.nanref-about__closing-inner>*',
    '.nanref-search__subhead',
    '.nanref-search__list>*',
    '.blog-post-item',
    '.nanref-footer__grid>*',
    '.nanref-footer__bottom',
    '[data-nr-sec]'
  ].join(',');

  var STEP = 60;      // ms between items entering together
  var MAX_STEPS = 6;  // cap so a long batch never waits more than 360ms
  var SETTLE = 1000;  // longest reveal transition (ms)

  function reveal(el, delay) {
    el.style.setProperty('--nr-d', delay + 'ms');
    el.setAttribute('data-nr-in', '');
    // Hand the element back to its normal styles (hover, press) once the reveal is over.
    setTimeout(function () {
      el.setAttribute('data-nr-done', '');
      el.style.removeProperty('--nr-d');
    }, delay + SETTLE);
  }

  var heard = false;
  var io = new IntersectionObserver(function (entries) {
    heard = true;
    var batch = [];
    entries.forEach(function (e) { if (e.isIntersecting) batch.push(e.target); });
    batch.sort(function (a, b) {
      var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
      return (ra.top - rb.top) || (ra.left - rb.left);
    });
    batch.forEach(function (el, i) {
      io.unobserve(el);
      var delay = Math.min(i, MAX_STEPS) * STEP;
      if (el.matches('.nanref-story__media')) {
        // The photos themselves are clipped while hidden, so the observer watches their wrapper.
        var imgs = el.querySelectorAll('.nanref-story__image,.nanref-story__image-float');
        for (var k = 0; k < imgs.length; k++) reveal(imgs[k], delay + k * 150);
      } else {
        reveal(el, delay);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function watch(el) {
    if (el.hasAttribute('data-nr-in') || el.__nrWatched) return;
    el.__nrWatched = true;
    io.observe(el);
  }

  // Content the list above doesn't cover (FAQ, policies, partner, blog articles, any new Horizon section) still reveals:
  // walk into each uncovered section and mark every block that starts below the first screen.
  // Blocks taller than the screen are split into their children, so long text pages reveal paragraph by paragraph.
  // Anything already on screen is never marked, so nothing visible on load ever blinks.
  var vh = window.innerHeight;
  var KEEP = '.buy-buttons-block,product-form-component,form,.cart-items,.cart__summary'; // forms and buying controls are never delayed
  function mark(el, depth) {
    var kids = el.children, list = [];
    for (var k = 0; k < kids.length; k++) {
      var c = kids[k];
      if (/^(STYLE|SCRIPT|TEMPLATE|LINK|DIALOG)$/.test(c.tagName) || c.classList.contains('section-background') || !c.offsetHeight) continue;
      var pos = getComputedStyle(c).position;
      if (pos === 'fixed' || pos === 'sticky' || pos === 'absolute') continue; // pinned bars and overlays stay put
      list.push(c);
    }
    if (list.length === 1 && depth < 10) { mark(list[0], depth + 1); return; }
    list.forEach(function (c) {
      if (c.matches(KEEP)) return;
      var r = c.getBoundingClientRect();
      var tall = (r.height > vh * 1.1 || c.querySelector(KEEP)) && c.children.length && depth < 10;
      if (r.top >= vh && !tall) {
        c.setAttribute('data-nr-sec', c.closest('.rte,rte-formatter') ? 't' : '');
      } else if (r.bottom > vh && c.children.length && depth < 10) {
        mark(c, depth + 1); // straddles the fold, or too tall to move as one piece
      }
    });
  }
  var main = document.getElementById('MainContent');
  if (main) {
    var secs = main.querySelectorAll(':scope>.shopify-section');
    for (var s = 0; s < secs.length; s++) {
      var sec = secs[s];
      if (sec.querySelector(SEL) || sec.matches(SEL)) continue;
      var sr = sec.getBoundingClientRect();
      if (sr.bottom <= vh) continue;
      if (sr.top >= vh && sr.height <= vh * 1.1 && !sec.querySelector(KEEP)) sec.setAttribute('data-nr-sec', '');
      else mark(sec, 0);
    }
  }

  var els = document.querySelectorAll(SEL);
  for (var i = 0; i < els.length; i++) watch(els[i]);

  // Cards added later (Load more, filters, re-rendered sections) must be watched too, or the CSS would keep them hidden.
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      for (var r = 0; r < records.length; r++) {
        var added = records[r].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          if (node.matches(SEL)) watch(node);
          var inner = node.querySelectorAll(SEL);
          for (var q = 0; q < inner.length; q++) watch(inner[q]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Failsafe: the observer always reports once per element right after observe().
  // If a visible page never hears from it, show everything rather than leave content hidden.
  setTimeout(function check() {
    if (heard || !els.length) return;
    if (document.visibilityState !== 'visible') { setTimeout(check, 1000); return; }
    root.classList.remove('nanref-motion');
  }, 2500);

  // Sticky header: show its soft shadow once the page has scrolled.
  var sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:24px;pointer-events:none;opacity:0';
  document.body.prepend(sentinel);
  new IntersectionObserver(function (e) {
    root.classList.toggle('nanref-scrolled', !e[0].isIntersecting);
  }).observe(sentinel);
})();
